









































































































































































import { Component, Vue, Watch, Provide } from "vue-property-decorator";

import {
  ticketClient,
  authorClient,
  client,
  collectionServiceClient,
} from "@/api/index";
import {
  GetAudioQualityTplListReq,
  Bool,
  AudioQualityTplData,
  SaveAudioQualityTplReq,
  AudioQualityScriptData,
  ModifyAudioQualityTemplateStatusReq,
} from "@/pbjs/external/ticket/ticket_pb";
import {
  ListUserGroupByTypeReq,
  ListUserGroupByMutiTypeReq,
} from "@/pbjs/external/auth/auth_pb";
import { ExecType } from "@/pbjs/xcommon/enum_pb";
import { timeFormat, downloadFile, setValue } from "@/utils/index";
import {
  SearchUserReq,
  BatchGetLoginInfoReq,
  GetOutSourceInfoReq,
} from "@/pbjs/external/user/user_pb";
import { pagnition } from "@/utils/commonConfig";
import { setCommon, handleResponse, setPage, errorMsg } from "@/utils/request";
import { Sort, Rank } from "@/pbjs/xcommon/common_pb";

@Component({
  name: "CombinationProperty",
  components: {
    // ReducePenalty,
    // ManualUpgradeTicketDialogue,
  },
})
export default class CombinationProperty extends Vue {
  @Provide() private resultData: any = [];
  @Provide() private pageIndex: number = 1;
  @Provide() private pageSize: number = 20;
  @Provide() private pagerCount: number = 0;
  @Provide() private pagnition: any = pagnition;
  @Provide() private userPageIndex: number = 1;
  @Provide() private userPagerCount: number = 0;
  @Provide() private showDialogType: number = 0;
  @Provide() private enabledstateOptions: any = [
    { id: 3, val: "ticketLgy.All" },
    { id: 1, val: "dashbordDy.activated" },
    { id: 2, val: "dashbordDy.terminated" },
  ];
  @Provide() private userForm: any = {
    TalkPointName: null,
    keywordsPhrases: null,
  };
  @Provide() private ruleForm: any = {
    templateName: null,
    enabledstate: null,
    founder: null,
  };
  @Provide() private rules: any = {
    keywordsPhrases: [
      {
        required: true,
        message: "请输入词库名称，最多15个字",
        trigger: "blur",
      },
      { min: 1, max: 15, message: "长度在 3 到 5 个字符", trigger: "blur" },
    ],
    TalkPointName: [
      { required: true, message: "请输入话术点", trigger: "blur" },
    ],
  };
  @Provide() private reloanOptions: any = [
    { name: "v0707.FirstLoan", value: Bool.BOOL_NO },
    { name: "v0707.Reloan", value: Bool.BOOL_YES },
  ];
  @Provide() private isGetTicketListActionDone: boolean = false;
  @Provide() private isShowManualUpgradeTicketDialogue: boolean = false;
  @Provide() private isGetTicketListExcelActionDone: boolean = false;
  @Provide() private system: any = localStorage.getItem("systemInfo");
  @Provide() private amountremained: any = "";
  @Provide() private isUseAmountRemained: boolean = false;
  @Provide() private isSearchUserActionDone: boolean = false;
  @Provide() private companyOptions: any = [];
  @Provide() private companyValue: number | null = null;
  @Provide() private outsourceOptions: any = [
    { name: "normal", value: Bool.BOOL_NO },
    { name: "outsourcing", value: Bool.BOOL_YES },
  ];
  @Provide() private sortCondition: any = {
    prop: null,
    order: null,
  };
  @Provide() private country: any = localStorage.getItem("country"); // 国家，字段差异化展示
  @Provide() private isShowSearchRegion: boolean = true;
  @Provide() private rollOptions: any = [
    { name: "Normal Ticket", value: Bool.BOOL_NO },
    { name: "Extension Ticket", value: Bool.BOOL_YES },
  ];

  @Provide() private StageOptions: any = [
    { name: "Single payment", value: Bool.BOOL_NO },
    { name: "Partial payment", value: Bool.BOOL_YES },
  ];

  @Provide() private dynamicTags: any = [];
  @Provide() private inputVisible: boolean = false;
  @Provide() private showDialogTypeId: number = 0;
  @Provide() private inputValue: any = "";
  @Provide() private showTimesTips: any = {
    showlefttotaltips: null,
    lefttotalgroup: "",
    lefttotalstaff: "",
  }; //减免次数展示
  private created() {
    this.getTicketList();
  }

  private handleClose(tag: any) {
    this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1);
  }

  private showInput() {
    this.inputVisible = true;
    this.$nextTick(() => {
      (this.$refs.saveTagInput as any).$refs.input.focus();
      // this.$refs.saveTagInput.$refs.input.focus();
    });
  }

  private handleInputConfirm() {

    let inputValue = this.inputValue;
    if (inputValue) {
      this.dynamicTags.push(inputValue);
    }
    this.inputVisible = false;
    this.inputValue = "";
  }

  private hideManualUpgradeTicketDialogue(val: any) {
    this.isShowManualUpgradeTicketDialogue = false;
  }
  private handleCurrentChange(val: any) {
    this.pageIndex = Number(val);
    //展示表格数据
    this.getTicketList();
  }
  private handleSizeChange(val: any) {
    this.pageSize = Number(val);
    //展示表格数据
    this.getTicketList();
  }
  private closeDialog() {
    this.showDialogType = 0;
  }
  //点击上一页
  private handlePrevChange(val: any) {
    if (this.pageIndex > 0) {
      //展示表格数据
      this.getTicketList();
    }
  }
  //点击下一页
  private handleNextChange(val: any) {
    //展示表格数据
    this.getTicketList();
  }
  private getTicketListAction() {
    this.isGetTicketListActionDone = true;
    this.pageIndex = 1;
    this.getTicketList();
  }
  private resetForm(formName: string) {
    const ref: any = this.$refs[formName];
    ref.resetFields();
  }

  private showOrHideSearchRegion() {
    this.isShowSearchRegion = !this.isShowSearchRegion;
  }
  //   addNewRules
  private addNewPoint(falg: any, val: any) {
    let routeData: any = this.$router.resolve({
      path: "/addNewTemplate",
      query: { id: falg == 1 ? val.id : "" },
    });
    window.open(routeData.href, "_blank");
  }
  //baocun
  private submitPoint(falg: any, row: any) {
    let requestAuto: any = new ModifyAudioQualityTemplateStatusReq(); //new AudioQualityTplData();
    requestAuto.setCommonin(setCommon());
    requestAuto.setId(Number(row.id));
    requestAuto.setStatus(falg);
    ticketClient.modifyAudioQualityTemplateStatus(
      requestAuto,
      {},
      (err: any, response: any) => {
        if (response) {
          let data: any = response.toObject();
          if (data.commonout.code == 0) {
            this.$message.success("success");
            this.showDialogType = 0;
            this.getTicketList();
          }
          // let _fuc = this.getRoleListAPIFuc;
          // handleResponse(data, _fuc);
        }
        if (err) {
          errorMsg(err);
        }
      }
    );
  }
  private sortChange(val: any) {
    switch (val.prop) {
      case "handlenum":
        this.sortCondition.prop = Sort.SORT_BY_HANDLE_NUM;
        break;
      case "lasthandletime":
        this.sortCondition.prop = Sort.SORT_BY_LAST_HANDLE_TIME;
        break;
      case "partialcompletetime":
        this.sortCondition.prop = Sort.SORT_BY_PARTIAL_COMPLETE_TIME;
        break;
      case "nexthandletime":
        this.sortCondition.prop = Sort.SORT_BY_PROMISE_REPAY_TIME;
        break;
      case "completetime":
        this.sortCondition.prop = Sort.SORT_BY_COMPLETE_TIME;
        break;
      case "overdueday":
        this.sortCondition.prop = Sort.SORT_BY_OVERDUE_DAY;
        break;
      case "remainamount":
        this.sortCondition.prop = Sort.SORT_BY_REMAIN_AMOUNT;
        break;
      default:
        this.sortCondition.prop = Sort.SORT_UNSPECIFIED;
        break;
    }
    switch (val.order) {
      case "descending":
        this.sortCondition.order = Rank.RANK_DESC;
        break;
      case "ascending":
        this.sortCondition.order = Rank.RANK_ASC;
        break;
      default:
        this.sortCondition.order = Rank.RANK_UNSPECIFIED;
        break;
    }
    this.getTicketListAction();
  }

  private getRoleListAPIFuc(data: any) {
    if (data.commonout.code == 0) {
      data.listList.forEach((item: any) => {
        let arr: any = [];
        item.rulelistList.forEach((item: any) => {
          arr.push(item.rulename);
        });
        item.Inclusionrules = arr.join(";");
        item.status1 =
          item.status == 1
            ? this.$tc("authority.Enable")
            : item.status == 2
            ? this.$tc("dashbordDy.Disable")
            : item.status == 0
            ? ""
            : this.$tc("authority.delete");
        item.scope =
          item.scope.itemname +
          ";" +
          ">=" +
          item.scope.duration +
          "s" +
          ";" +
          item.scope.rolename;
        item.ctime = item.ctime && timeFormat(item.ctime);
        item.score =
          item.scorepolicy == 1 ? "+" + item.score : "-" + item.score;
        item.scorepolicy =
          item.scorepolicy == 1
            ? this.$tc("dashbordDy.AddPoints")
            : this.$tc("dashbordDy.MinusPoints");
      });
      if (data.pageout || data.total) {
        this.pagerCount = data.total ? data.total : data.pageout.total;
      }
      this.resultData = data.listList;
      this.isGetTicketListActionDone = false;
    }
  }

  private getTicketList() {
    let request: any = new GetAudioQualityTplListReq();
    request.setCommonin(setCommon());
    request.setPagein(
      setPage(
        this.pageIndex,
        this.pageSize,
        this.sortCondition.prop,
        this.sortCondition.order
      )
    );
    let requestAuto: any = new AudioQualityTplData();
    requestAuto.setId();
    requestAuto.setTplname(this.ruleForm.templateName);
    requestAuto.setStatus(
      this.ruleForm.enabledstate == 3 ? "" : this.ruleForm.enabledstate //3为不限，所以为空
    );
    requestAuto.setUsername(this.ruleForm.founder);
    request.setData(requestAuto);
    ticketClient.getAudioQualityTemplateList(
      request,
      {},
      (err: any, response: any) => {
        if (response) {
          let data: any = response.toObject();
          let _fuc = this.getRoleListAPIFuc;
          handleResponse(data, _fuc);
        }
        if (err) {
          errorMsg(err);
        }
      }
    );
  }
}
